var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.31 116.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,58c-.16-18.63,15.44-34,34-34.09a34.21,34.21,0,1,1,.1,68.42C42.45,92.34,26.74,76.91,27,58Zm9.21,16.16v.31a16.73,16.73,0,0,0,2.1.26c9.5.06,19,.12,28.5.13,6,0,11.93-.06,17.89-.13a5.2,5.2,0,0,0,1.25-.31l0-.29L69,58.27c-1.48,1.32-2.92,2.48-4.2,3.79-1.56,1.59-5.31,1.63-6.7.27-.68-.66-1.42-1.25-2.12-1.88L53.4,58.16Zm2.88-32.64c.44.42.7.69,1,.94,1.84,1.68,3.7,3.35,5.53,5,4.41,4,8.79,8.12,13.2,12.17,1.81,1.66,2.75,1.66,4.67.11.21-.17.4-.35.59-.53L81,43.61l2.09-1.94L83,41.52Zm12.55,15-5.45-5.06q-4.76-4.4-9.51-8.77c-.6-.55-.9-.48-1,.32a15.37,15.37,0,0,0-.19,2.45q0,12.73-.05,25.45c0,.18,0,.35.06.58ZM86.34,42.17,70.77,56.54,86.9,71.59v-.72c0-6.4,0-12.8,0-19.19,0-2.69-.08-5.38-.16-8.07A6.53,6.53,0,0,0,86.34,42.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/MAIL.6c866ef32af68cef3c56288805b770dc.svg";
export { ForwardRef as ReactComponent };